import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { formatDateFa, toFaDigits } from '../../utils/format'
import toast from 'react-hot-toast'

const Profile: React.FC = () => {
  const { user, updateProfile, changePassword } = useAuth()
  const [info, setInfo] = useState({ firstName: user?.firstName || '', lastName: user?.lastName || '', phone: user?.phone || '' })
  const [pwd, setPwd] = useState({ currentPassword: '', newPassword: '', confirm: '' })
  const [infoSaving, setInfoSaving] = useState(false)
  const [pwdSaving, setPwdSaving] = useState(false)
  const [activeTab, setActiveTab] = useState<'info' | 'password'>('info')

  if (!user) return null

  const saveInfo = async () => {
    setInfoSaving(true)
    try {
      await updateProfile(info)
      toast.success('پروفایل به‌روزرسانی شد')
    } catch (err: any) {
      toast.error(err?.response?.data?.message || err.message || 'خطا در ذخیره اطلاعات')
    } finally {
      setInfoSaving(false)
    }
  }

  const savePassword = async () => {
    if (pwd.newPassword.length < 8) {
      toast.error('رمز عبور جدید باید حداقل ۸ کاراکتر باشد')
      return
    }
    if (pwd.newPassword !== pwd.confirm) {
      toast.error('تکرار رمز عبور مطابقت ندارد')
      return
    }
    setPwdSaving(true)
    try {
      await changePassword(pwd.currentPassword, pwd.newPassword)
      toast.success('رمز عبور تغییر کرد')
      setPwd({ currentPassword: '', newPassword: '', confirm: '' })
    } catch (err: any) {
      toast.error(err?.response?.data?.message || err.message || 'خطا در تغییر رمز عبور')
    } finally {
      setPwdSaving(false)
    }
  }

  return (
    <div className="container-main py-10">
      <h1 className="text-2xl font-black text-gray-900 mb-6">حساب کاربری</h1>

      <div className="card p-6 mb-6">
        <div className="flex items-center gap-4">
          <div className="w-14 h-14 bg-primary-100 text-primary-700 rounded-full flex items-center justify-center text-xl font-black">
            {user.firstName[0] || '؟'}
          </div>
          <div>
            <div className="font-black text-gray-900">{user.firstName} {user.lastName}</div>
            <div className="text-sm text-gray-500">{user.email}</div>
          </div>
          <div className="mr-auto text-xs text-gray-400">عضو از {formatDateFa(user.createdAt)}</div>
        </div>
      </div>

      <div className="flex items-center gap-2 mb-6">
        {['info', 'password'].map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab as 'info' | 'password')}
            className={`px-5 py-2 rounded-lg text-sm font-bold ${activeTab === tab ? 'bg-primary-100 text-primary-800' : 'bg-gray-100 text-gray-600'}`}
          >
            {tab === 'info' ? 'اطلاعات شخصی' : 'تغییر رمز عبور'}
          </button>
        ))}
        <Link to="/orders" className="px-5 py-2 rounded-lg bg-gray-100 text-gray-600 text-sm font-bold">سفارش‌های من</Link>
      </div>

      {activeTab === 'info' ? (
        <div className="card p-6 max-w-xl">
          <h2 className="font-black text-gray-900 mb-4">اطلاعات شخصی</h2>
          <div className="grid sm:grid-cols-2 gap-4">
            <div>
              <label className="label">نام</label>
              <input className="input" value={info.firstName} onChange={(e) => setInfo((p) => ({ ...p, firstName: e.target.value }))} />
            </div>
            <div>
              <label className="label">نام خانوادگی</label>
              <input className="input" value={info.lastName} onChange={(e) => setInfo((p) => ({ ...p, lastName: e.target.value }))} />
            </div>
            <div className="sm:col-span-2">
              <label className="label">شماره موبایل</label>
              <input className="input" dir="ltr" value={info.phone || ''} onChange={(e) => setInfo((p) => ({ ...p, phone: e.target.value }))} />
            </div>
          </div>
          <button className="btn btn-primary w-full !py-3 mt-4 disabled:opacity-50" disabled={infoSaving} onClick={saveInfo}>
            {infoSaving ? 'در حال ذخیره…' : 'ذخیره تغییرات'}
          </button>
        </div>
      ) : (
        <div className="card p-6 max-w-xl">
          <h2 className="font-black text-gray-900 mb-4">تغییر رمز عبور</h2>
          <div className="space-y-4">
            <div>
              <label className="label">رمز عبور فعلی</label>
              <input type="password" className="input" dir="ltr" value={pwd.currentPassword} onChange={(e) => setPwd((p) => ({ ...p, currentPassword: e.target.value }))} />
            </div>
            <div>
              <label className="label">رمز عبور جدید</label>
              <input type="password" className="input" dir="ltr" value={pwd.newPassword} onChange={(e) => setPwd((p) => ({ ...p, newPassword: e.target.value }))} />
            </div>
            <div>
              <label className="label">تکرار رمز عبور جدید</label>
              <input type="password" className="input" dir="ltr" value={pwd.confirm} onChange={(e) => setPwd((p) => ({ ...p, confirm: e.target.value }))} />
            </div>
          </div>
          <button className="btn btn-primary w-full !py-3 mt-4 disabled:opacity-50" disabled={pwdSaving} onClick={savePassword}>
            {pwdSaving ? 'در حال تغییر…' : 'تغییر رمز عبور'}
          </button>
        </div>
      )}

      <p className="text-xs text-gray-400 mt-8">
        شناسه کاربری: {toFaDigits(user.id.slice(0, 8))}
      </p>
    </div>
  )
}

export default Profile